module.exports = __webpack_public_path__ + "img/image_delivery.0d399ec5.svg";